<template>
  <div v-if="items.data && items.data.length > 0">
    <div class="row">
      <div class="col ml-3">
        <section-title
          content="Historial de Rechazos de Servicio"
          container-class="mt-4 mb-4"
        />
      </div>
    </div>
    <div v-for="(item, index) in items.data" :key="index" class="row">
      <div class="col">
        <div class="mb-4 mx-3">
          <div class="row grayish-lighter m-0 rounded p-2 border-left-gray">
            <div
              class="col-sm-12 col-md-12 col-lg-12 py-md-3 py-2 pl-md-2 pl-2"
            >
              <div class="row">
                <div class="col-md-4 border-history-separator">
                  <div
                    class="col-12 col-md-12 d-flex flex-column border-right-2"
                  >
                    <small class="student-label mb-1">Fecha:</small>
                    <span class="student-name">
                      {{ formatDate(item.referralDate) }}
                    </span>
                  </div>
                  <div class="col-12 col-md-12 d-flex flex-column pt-4">
                    <small class="student-label mb-1">Acción:</small>
                    <span class="student-name">{{ item.action }}</span>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="row">
                    <div class="col-12 col-md-6 d-flex flex-column">
                      <small class="student-label mb-1">Proveedor:</small>
                      <span class="student-name">{{ item.companyName }}</span>
                    </div>
                    <div class="col-md-6 d-flex flex-column">
                      <small class="student-label mb-1">Lugar de Servicio:</small>
                      <span class="student-name">{{ item.locationName }}</span>
                    </div>                 
                    <div class="col-12 col-md-6 d-flex flex-column pt-4">
                      <small class="student-label mb-1">Razón:</small>
                      <span class="student-name">{{ item.reason }}</span>
                    </div>
                    <div class="col-md-6 d-flex flex-column pt-4">
                      <small class="student-label mb-1">Comentario:</small>
                      <span class="student-name">{{ item.comment }}</span>
                    </div>                     
                    <div v-if="item.documentId" class="col-12 col-md-12 d-flex flex-column pt-4">
                      <small class="student-label mb-1">Documento de Rechazo de Servicios:</small>     
                      <div class="d-flex justify-content-start">
                        <custom-file-input
                          ref="fileUpload"                        
                          display-style="normal"                                            
                          label-position="left"
                          :attachment-id="item.documentId"                  
                          :disabled="true"                                      
                          :name="item.documentTitle"
                          :on-download="()=> downloadFile(item.documentId)"                        
                        />
                        <action-button                   
                          v-if="canShowReplaceRejectionDocument"
                          class="btn mr-2 ml-2 p-0 button-container"
                          i="fas fa-undo-alt"
                          variant="outline-success"
                          @click="
                            onReplaceFileHandler(`fileRef-${item.documentId}`)
                          "
                        />
                        <input
                          :id="`file-${item.documentId}`"
                          :ref="`fileRef-${item.documentId}`"
                          accept=".pdf"
                          style="display: none"
                          type="file"
                          @change="
                            onUploadFileHandler(
                              item.admissionId,
                              item.documentId,
                              `fileRef-${item.documentId}`
                            )
                          "
                        />
                      </div>                                        
                    </div>
                  </div>                  
                </div>             
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <customPager
          ref="pagerRef"
          :per-page="pagination.perPage"
          :total="pagination.totalItemCount"
          :page-changed="onPageChange"
          class="mx-3"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import CustomFileInput from "CustomFileInput";
import moment from 'moment';
import DocumentsService from "@/services/documents";
import ActionButton from "ActionButton";
import objectToFormData from "object-to-formdata";
import alert from "@/mixin/alert.mixin";
import ReferralService from '@/modules/referral/api';

export default {
  name: 'RejectionHistory',
  mixins: [alert],
  data() {
    return {
      pagination: {
        perPage: 5,
        totalItemCount: 0,
      },
    };
  },
  components: {
    SectionTitle,
    CustomFileInput,
    ActionButton
  },
  props: {
    items: {
      type: Object,
      default() {
        return {
          count: 0,
          currentPage: 1,
          data: [],
          pageCount: 1,
          totalItemCount: 0,
        };
      },
    },
  },
  computed:{
    canShowReplaceRejectionDocument(){
      return this.userHasPermissions("pei.referralmanagement.deniedreferralreplacedocument");   
    }
  },
  watch: {
    items(newVal, oldVal) {
      if (newVal != oldVal) {
        this.pagination.totalItemCount = newVal.totalItemCount;
      }
    },
  },
  methods: {
    onPageChange(params) {
      this.$emit('on-page-change', params);
    },
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    async downloadFile(documentId)
    {
      await DocumentsService.downloadDocumentByAttachmentIdOrDocumentId(documentId)
    },
    onReplaceFileHandler(refName) {
      const ref = this.$refs[refName];

      if (Array.isArray(ref)) {
        ref[0]?.click?.(); // El ?. previene el error si no es función
      } else {
        ref?.click?.();
      }
    },
    async onUploadFileHandler(admissionId, fileIdToReplace,refName) {
      const ref = this.$refs[refName];

      let files = ref[0]?.files;

      if (files.length > 0) {
        const formData = {
          admissionId: admissionId,
          fileIdToReplace: fileIdToReplace,         
          file: files[0],
        };

        const payload = objectToFormData(formData, { indices: true });        
        await ReferralService.replaceServiceRejectionFile(payload);

        this.ShowToast(
          '',
          'El documento ha sido reemplazado exitosamente.',
          'success'
        );
        this.$emit('on-page-change', {
          currentPage: 1
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.button-container {
  min-width: 33px;
  height: 33px;
}

.grayish-lighter {
  background-color: #f7f7f7;
}
.border-left-gray {
  border-left: 4px solid #e2e2e2;
}
.border-separator {
  border-right-width: 2px;
  border-right-style: solid;
  border-right-color: #6c757d24;
}

.border-history-separator {
  border-right: 2px solid #d9d9d9;
}

.student-label {
  text-align: left;
  font-size: 16px;
  letter-spacing: 0px;
  color: #727272;
}

.student-name {
  text-align: left;
  font: Regular 16px/28px Lato;
  letter-spacing: 0px;
  color: #11291b;
}
</style>
